import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=8891b8b8&scoped=true&"
import script from "./NotificationsWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsWidget.vue?vue&type=style&index=0&id=8891b8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8891b8b8",
  null
  
)

export default component.exports